// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export { registerBackend } from './backend-impl.js';
//# sourceMappingURL=backend.js.map